import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { utils, checkWin } from "@alife/cone-arms-core";
import { hookMtop } from "./hook-mtop";
import { getTraceId, checkIgnoreUrl, extendLogItemWithResponse, extendRequestAndResponseSizes, parseServerTimingHeader, getXhrHeaderByName, getFullUrl, appendServerTimingToLogItem, extendLogItemWithTimeZone, genRequestId, initLongTaskObserver, isSSEMessage, isSSEEventStream } from "./utils";
var supportedEntryType = utils.supportedEntryType;
// 默认采样率0.1
var DEFAULT_SAMPLING = 0.1;
// 二进制流的文件正则
var streamFileTypes = [
    ".bmp",
    ".jpg",
    ".png",
    ".gif",
    ".ogg",
    ".mpeg4",
    ".webm"
];
// 判断string类型
function isString(s) {
    return typeof s === "string";
}
var TraceApiPlugin = function(core, config) {
    var _ref = config || {}, _ref_disableXhr = _ref.disableXhr, disableXhr = _ref_disableXhr === void 0 ? false : _ref_disableXhr, _ref_disableFetch = _ref.disableFetch, disableFetch = _ref_disableFetch === void 0 ? false : _ref_disableFetch, _ref_sampling = _ref.sampling, sampling = _ref_sampling === void 0 ? DEFAULT_SAMPLING : _ref_sampling, _ref_disableMtop = _ref.disableMtop, disableMtop = _ref_disableMtop === void 0 ? true : _ref_disableMtop, _ref_enableParams = _ref.enableParams, enableParams = _ref_enableParams === void 0 ? true : _ref_enableParams, _ref_ignore = _ref.ignore, ignore = _ref_ignore === void 0 ? [] : _ref_ignore, _ref_traceIdHeaderName = _ref.traceIdHeaderName, traceIdHeaderName = _ref_traceIdHeaderName === void 0 ? "" : _ref_traceIdHeaderName;
    var hadReportPerformanceMap = {};
    var genCachePerformanceKey = function(perfInstance) {
        return "".concat(perfInstance.initiatorType, "-").concat(perfInstance.name, "-").concat(perfInstance.startTime, "-").concat(perfInstance.duration);
    };
    var getServerTimingList = function(requestType, url, res, dur) {
        var _res;
        var serverTimingHeader;
        if (requestType === "xhr") {
            serverTimingHeader = getXhrHeaderByName(res, "server-timing");
        } else if (((_res = res) === null || _res === void 0 ? void 0 : _res.headers) && typeof res.headers.get === "function") {
            serverTimingHeader = res.headers.get("server-timing");
        }
        if (serverTimingHeader) {
            var serverTimingList = parseServerTimingHeader(serverTimingHeader);
            if (serverTimingList.length > 0) {
                return serverTimingList;
            }
        }
        var performanceEntry = getMatchPerformanceEntry(requestType, url, dur);
        if (performanceEntry) {
            return performanceEntry.serverTiming || [];
        }
        return [];
    };
    var getMatchPerformanceEntry = function(requestType, url, dur) {
        var startTime = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        if (supportedEntryType("resource")) {
            var initiatorType = requestType === "xhr" ? "xmlhttprequest" : "fetch";
            var resourceTimingList = performance.getEntriesByType("resource").filter(function(entry) {
                var cacheKey = genCachePerformanceKey(entry);
                var urlMatch = entry && entry.initiatorType === initiatorType && // 请求路径匹配
                entry.name === url;
                return !hadReportPerformanceMap[cacheKey] && urlMatch && (dur > 0 && // 请求耗时匹配
                Math.abs(entry.duration - dur) < 50 || startTime > 0 && // 请求开始时间匹配
                Math.abs(entry.connectStart - startTime) < 5);
            });
            if (resourceTimingList.length > 0) {
                return resourceTimingList[resourceTimingList.length - 1];
            }
        }
        return null;
    };
    if (!checkWin()) {
        return;
    }
    var win = utils.getWin();
    // 监听长任务
    var longTaskObserverHandler = initLongTaskObserver();
    // 重写xhr
    var originXhrOpen;
    var originXhrSend;
    if (!disableXhr) {
        if (win) {
            // 用来记录参数
            var XHR = win.XMLHttpRequest;
            var originXhrProto = XHR.prototype;
            originXhrOpen = originXhrProto.open;
            originXhrSend = originXhrProto.send;
            /**
       * 重写open 记录method和url
       * @param method
       * @param url
       */ // @ts-ignore 重载open方法
            originXhrProto.open = function TraceApiPlugin(method) {
                var url = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                for(var _len = arguments.length, restArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    restArgs[_key - 2] = arguments[_key];
                }
                var _originXhrOpen;
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var fakeXhr = this;
                var requestId = genRequestId(url);
                fakeXhr.__recordInfo__ = {
                    method: (method || "get").toUpperCase(),
                    url: url,
                    startTime: new Date().getTime(),
                    requestId: requestId
                };
                longTaskObserverHandler.start(requestId);
                (_originXhrOpen = originXhrOpen).call.apply(_originXhrOpen, [
                    this,
                    method,
                    url
                ].concat(_to_consumable_array(restArgs)));
            };
            // 重新send
            originXhrProto.send = function(data) {
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var xhr = this;
                var url = (xhr.__recordInfo__ || {}).url;
                var requestStartPerformanceNow = 0;
                // ignore为true时不做统计
                if (!checkIgnoreUrl(url, ignore)) {
                    var originOnreadystatechange = this.onreadystatechange;
                    var endTime = null;
                    var firstTokenTime = null;
                    var isSSE = false;
                    var hackOnReadyStateChangeHandler = function() {
                        try {
                            if (!isSSE && xhr.readyState >= 3 && typeof xhr.getResponseHeader === "function") {
                                var _contentType;
                                var contentType = xhr.getResponseHeader("Content-Type");
                                isSSE = (_contentType = contentType) === null || _contentType === void 0 ? void 0 : _contentType.includes("text/event-stream");
                            }
                            // 记录第一个 token 的时间
                            if (isSSE && !firstTokenTime && xhr.readyState === 3 && xhr.responseText) {
                                firstTokenTime = new Date().getTime();
                            }
                            if (xhr.__recordInfo__ && xhr.readyState === 4) {
                                var isGET = xhr.__recordInfo__.method === "GET";
                                // 当启用mtop hook时，mtop接口不再走xhr监听，走mtop
                                if (!disableMtop && url.indexOf("api=") !== -1 && url.indexOf("v=") !== -1 && url.indexOf("jsv=") !== -1) {
                                    return;
                                }
                                var finalUrl = url.split("?")[0] || "";
                                var urlQuery = url.split("?")[1];
                                var startTime = xhr.__recordInfo__.startTime;
                                var isStreamFile = streamFileTypes.some(function(file) {
                                    var _finalUrl;
                                    return ((_finalUrl = finalUrl) === null || _finalUrl === void 0 ? void 0 : _finalUrl.indexOf(file)) !== -1;
                                });
                                var params;
                                // 当请求被取消或 timeout 时为 0
                                if (xhr.status === 0) {
                                    return;
                                }
                                // 流式文件类型的情况不统计
                                if (isStreamFile) {
                                    return;
                                }
                                // 返回头content-type非text,json不统计
                                if (typeof xhr.getResponseHeader === "function") {
                                    var cType = xhr.getResponseHeader("Content-Type");
                                    if (cType && !/(text)|(json)/.test(cType)) {
                                        return;
                                    }
                                }
                                // 当请求方法get或者data为空时，params为urlQuery
                                if (!enableParams) {
                                    params = "";
                                } else if (isGET || !data) {
                                    params = urlQuery;
                                } else {
                                    params = typeof data === "object" ? JSON.stringify(data) : data;
                                }
                                var success = xhr.status >= 200 && xhr.status < 300;
                                var apiFullPath = getFullUrl(finalUrl);
                                var performanceEntry = getMatchPerformanceEntry("xhr", apiFullPath, 0, requestStartPerformanceNow);
                                var costTime;
                                if (performanceEntry && performanceEntry.duration) {
                                    costTime = Math.ceil(performanceEntry.duration);
                                } else if (typeof endTime === "number" && typeof startTime === "number") {
                                    costTime = endTime - startTime;
                                }
                                var logItem = {
                                    api: finalUrl,
                                    // response: xhr.response,
                                    httpCode: xhr.status,
                                    success: success,
                                    params: params,
                                    time: costTime,
                                    requestType: isSSE ? "sse" : "xhr",
                                    method: isGET ? "GET" : "POST",
                                    // api失败情况不采样
                                    sampling: success && typeof sampling === "number" ? sampling : 1,
                                    longTaskCount: longTaskObserverHandler.end(xhr.__recordInfo__.requestId)
                                };
                                if (isSSE && firstTokenTime) {
                                    logItem.firstTokenTime = firstTokenTime - startTime;
                                }
                                logItem.traceId = getTraceId("xhr", xhr, traceIdHeaderName);
                                if (({}).toString.call(xhr.response) === "[object Blob]") {
                                    return;
                                }
                                var res = {};
                                try {
                                    if (isSSE) {
                                        res = xhr.responseText;
                                    } else {
                                        res = typeof xhr.response === "string" ? JSON.parse(xhr.response) : xhr.response;
                                    }
                                } catch (err) {
                                    if (!isSSE) {
                                        logItem.msg = "response isn't type json";
                                    }
                                }
                                var serverTimingList = performanceEntry && Array.isArray(performanceEntry.serverTiming) ? performanceEntry.serverTiming : getServerTimingList("xhr", xhr.__recordInfo__.url, xhr, logItem.time);
                                logItem.api = apiFullPath;
                                appendServerTimingToLogItem(logItem, serverTimingList);
                                extendLogItemWithResponse(logItem, res);
                                extendRequestAndResponseSizes(logItem, data, res);
                                extendLogItemWithTimeZone(logItem);
                                if (typeof config.evaluate === "function") {
                                    var ret;
                                    try {
                                        ret = config.evaluate(res, xhr, "xhr", {
                                            method: xhr.__recordInfo__.method,
                                            url: url,
                                            data: data
                                        });
                                    } catch (e) {
                                    // ignore evaluate error
                                    }
                                    // 若返回 object，则说明接口出错了，返回的 object 包含了需要打点的字段
                                    if (typeof ret === "object") {
                                        utils.shadowMerge(logItem, ret);
                                    }
                                }
                                logItem.api = getFullUrl(logItem.api);
                                core.logApi(logItem);
                                // 记录已经上报过的performanceEntry
                                if (performanceEntry) {
                                    hadReportPerformanceMap[genCachePerformanceKey(performanceEntry)] = true;
                                }
                            }
                        } catch (e) {
                        // ignore error
                        }
                    };
                    xhr.onreadystatechange = function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        // 及时记录请求结束时间
                        endTime = new Date().getTime();
                        if (typeof originOnreadystatechange === "function") {
                            originOnreadystatechange.apply(xhr, args);
                        }
                        hackOnReadyStateChangeHandler.apply(xhr);
                    };
                }
                originXhrSend.call(this, data);
                this.__recordInfo__.startTime = new Date().getTime();
                if (typeof performance === "object" && performance.now) {
                    requestStartPerformanceNow = performance.now();
                }
            };
        }
    }
    // 重写fetch
    var originFetch;
    if (!disableFetch && win) {
        var _originFetch;
        originFetch = win.fetch;
        // 如果是polyfill的fetch，不重写。因为重写后会导致一个fetch请求被上报两次(xhr 和 fetch)
        // @ts-ignore polyfill
        if (originFetch && !((_originFetch = originFetch) === null || _originFetch === void 0 ? void 0 : _originFetch.polyfill)) {
            win.fetch = function(input, data) {
                try {
                    var url;
                    var method;
                    var mode;
                    // 增加开始时间
                    var startTime = new Date().getTime();
                    if (isString(input)) {
                        var _data_method, _data, _data1;
                        url = input;
                        method = ((_data = data) === null || _data === void 0 ? void 0 : (_data_method = _data.method) === null || _data_method === void 0 ? void 0 : _data_method.toUpperCase()) || "GET";
                        mode = (_data1 = data) === null || _data1 === void 0 ? void 0 : _data1.mode;
                    } else {
                        var _input, _input1, _input_method, _input2, _input3;
                        url = ((_input = input) === null || _input === void 0 ? void 0 : _input.url) || ((_input1 = input) === null || _input1 === void 0 ? void 0 : _input1.href) || "";
                        method = ((_input2 = input) === null || _input2 === void 0 ? void 0 : (_input_method = _input2.method) === null || _input_method === void 0 ? void 0 : _input_method.toUpperCase()) || "GET";
                        mode = (_input3 = input) === null || _input3 === void 0 ? void 0 : _input3.mode;
                    }
                    var isGET = method === "GET";
                    var finalUrl = url.split("?")[0] || "";
                    var urlQuery = url.split("?")[1] || "";
                    var params = "";
                    var isStreamFile = streamFileTypes.some(function(file) {
                        var _finalUrl;
                        return ((_finalUrl = finalUrl) === null || _finalUrl === void 0 ? void 0 : _finalUrl.indexOf(file)) !== -1;
                    });
                    // method: 'HEAD' 或 mode: 'no-cors' 或 流式文件类型 或 ignore 方法为true 的请求不监听
                    if (method === "HEAD" || mode === "no-cors" || isStreamFile || checkIgnoreUrl(url, ignore)) {
                        return originFetch.call(this, input, data);
                    }
                    // 当请求方法get或者data为空时，params为urlQuery
                    if (!enableParams) {
                        params = "";
                    } else if (isString(input)) {
                        if (isGET || !data) {
                            params = urlQuery;
                        } else {
                            params = typeof data === "object" ? JSON.stringify(data) : data;
                        }
                    }
                    var logItem = {
                        api: finalUrl,
                        params: params,
                        requestType: "fetch",
                        method: isGET ? "GET" : "POST"
                    };
                    var requestId = genRequestId(url);
                    longTaskObserverHandler.start(requestId);
                    return originFetch.call(this, input, data).then(function(res) {
                        try {
                            var responseHeaders = res.headers;
                            if (responseHeaders && typeof responseHeaders.get === "function") {
                                // 返回头content-type非text,json不统计
                                var cType = responseHeaders.get("content-type");
                                if (cType && !/(text)|(json)/.test(cType)) {
                                    return res;
                                }
                            }
                            if (isSSEMessage(res)) {
                                setTimeout(function() {
                                    logItem.requestType = "sse";
                                    logItem.time = new Date().getTime() - startTime;
                                    logItem.httpCode = res.status;
                                    // SSEMessage强制按0.1采样
                                    logItem.sampling = 0.1;
                                    logItem.api = getFullUrl(finalUrl);
                                    logItem.method = "POST";
                                    core.logApi(logItem);
                                }, 0);
                                return res;
                            } else if (isSSEEventStream(res)) {
                                // SSEEventStream获取第一个token的时间
                                var firstTokenTime = new Date().getTime();
                                logItem.firstTokenTime = firstTokenTime - startTime;
                                logItem.requestType = "sse";
                                logItem.time = firstTokenTime - startTime;
                                logItem.httpCode = res.status;
                                logItem.sampling = 0.1;
                                logItem.api = getFullUrl(finalUrl);
                                logItem.method = "POST";
                                core.logApi(logItem);
                                return res;
                            }
                            res.clone().text().then(function(text) {
                                var _data;
                                var success = res.status >= 200 && res.status < 300;
                                var endTime = new Date().getTime();
                                logItem.httpCode = res.status;
                                logItem.success = success;
                                logItem.headers = JSON.stringify(res.headers);
                                logItem.time = typeof endTime === "number" && typeof startTime === "number" ? endTime - startTime : undefined;
                                logItem.sampling = success && typeof sampling === "number" ? sampling : 1; // api失败情况不采样
                                var apiFullPath = getFullUrl(finalUrl);
                                logItem.api = apiFullPath;
                                var serverTimingList = getServerTimingList("fetch", url, res, logItem.time);
                                appendServerTimingToLogItem(logItem, serverTimingList);
                                extendLogItemWithResponse(logItem, text);
                                extendLogItemWithTimeZone(logItem);
                                extendRequestAndResponseSizes(logItem, (_data = data) === null || _data === void 0 ? void 0 : _data.body, text);
                                var ret;
                                try {
                                    var _config;
                                    ret = typeof ((_config = config) === null || _config === void 0 ? void 0 : _config.evaluate) === "function" ? config.evaluate(text, res, "fetch", {
                                        method: method,
                                        url: finalUrl,
                                        data: data
                                    }) : {};
                                } catch (e) {
                                // ignore error
                                }
                                if (typeof ret === "object" && ret !== null) {
                                    utils.shadowMerge(logItem, ret);
                                }
                                logItem.longTaskCount = longTaskObserverHandler.end(requestId);
                                core.logApi(logItem);
                            });
                        } catch (e) {
                            var _e;
                            core.logCustom({
                                pid: "arms-debug",
                                p1: "api",
                                c1: core.getConfig("pid"),
                                c2: finalUrl,
                                c3: (_e = e) === null || _e === void 0 ? void 0 : _e.message
                            });
                        }
                        return res;
                    });
                } catch (e) {
                    var _e;
                    // 上报到fsp, c1应用名, c2请求的url
                    core.logCustom({
                        pid: "arms-debug",
                        p1: "api",
                        c1: core.getConfig("pid"),
                        c3: (_e = e) === null || _e === void 0 ? void 0 : _e.message
                    });
                }
            };
        }
    }
    var unHookMtop;
    if (!disableMtop) {
        unHookMtop = hookMtop(core, config);
    }
    return function() {
        try {
            if (originXhrOpen && originXhrSend) {
                // 用来记录参数
                var XHR = win.XMLHttpRequest;
                var originXhrProto = XHR.prototype;
                originXhrProto.open = originXhrOpen;
                originXhrProto.send = originXhrSend;
            }
            if (originFetch) {
                win.fetch = originFetch;
            }
            if (unHookMtop && typeof unHookMtop === "function") {
                unHookMtop();
            }
            longTaskObserverHandler.stop();
        } catch (error) {
            console.warn("[ARMS WARN]api插件卸载错误", error);
        }
    };
};
export { extendLogItemWithResponse };
export default TraceApiPlugin;

 //# sourceMappingURL=index.js.map